import {SchemaInfo} from 'processes/modals/field-mapping/FieldMappingConstants';
import {BaseSectionedNodeSectionData} from 'ui-library/reactflow/nodes/BaseSectionedNodeRenderer/BaseSectionedNodeRendererTypes';

import {TaskSchemaNodeRowData} from './TaskSchemaNodeRenderer';

export type TaskSchemaNodeRendererSection = BaseSectionedNodeSectionData<TaskSchemaNodeRowData>;

export interface TaskDefinition {
  schemaInfo: SchemaInfo;
}

/**
 * Abstract class for creating sections of a node in a ProcessFlowchart.
 * For each node type, a different adapter can be created to handle
 * converting the task definition into a node to use in a flowchart.
 */
export abstract class ProcessFlowchartNodeAdapter<TNodeAdapterOptions> {
  constructor(protected readonly options: TNodeAdapterOptions) {}

  abstract createSections(taskDefinition: TaskDefinition): Array<TaskSchemaNodeRendererSection>;
}
